import { AppTile } from './app-tile';

export class ChannelTermAppTile {
  public AppTile: AppTile;
  public AppTileId: number;
  public ChannelTermId: string;

  constructor(opt?: Partial<ChannelTermAppTile>) {
    Object.assign(this, opt);
  }
}
